import { useCallback, useEffect, useMemo, useState } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const StyledErrorContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
}));

export const Error = () => {
  const [remianingTime, setRemianingTime] = useState<number>(60);

  const reloadPage = useCallback(() => {
    window.location.reload();
  }, []);

  const reloadButton = useMemo(
    () => (
      <Button color="error" onClick={reloadPage}>
        Перезагрузить страницу сейчас
      </Button>
    ),
    [reloadPage],
  );

  useEffect(() => {
    const timer = setInterval(
      () => setRemianingTime((prevState) => --prevState),
      1000,
    );

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (remianingTime === 1) {
      reloadPage();
    }
  }, [remianingTime, reloadPage]);

  return (
    <StyledErrorContainer>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Typography variant="h3" textAlign="center">
          Извините, что-то пошло не так
        </Typography>
        <Typography variant="h5" textAlign="center">
          Страница перезагрузится через {remianingTime} сек.
        </Typography>
        {reloadButton}
      </Box>
    </StyledErrorContainer>
  );
};
